import React from 'react';
import { useConsent } from '../contexts/ConsentContext';

/**
 * ConsentBanner Component
 * 
 * Displays a compact, modern consent banner when user hasn't set preferences yet.
 * Professional, minimal design with close button.
 */
export const ConsentBanner = () => {
  const { hasConsentBeenSet, acceptAll, rejectAll, isLoaded } = useConsent();

  // Don't render if consent has been set or not loaded yet
  if (!isLoaded || hasConsentBeenSet) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 left-4 sm:left-auto z-50 max-w-md mx-auto sm:mx-0">
      <div className="bg-white rounded-xl shadow-xl border border-gray-100 p-4 sm:p-5">
        {/* Close Button */}
        <button
          onClick={rejectAll}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-full p-1"
          aria-label="Close"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Content */}
        <div className="pr-8">
          <p className="text-sm text-gray-700 leading-relaxed mb-4">
            We use cookies to enhance your experience. By continuing, you agree to our use of cookies.
          </p>

          {/* Action Buttons */}
          <div className="flex items-center gap-2">
            <button
              onClick={rejectAll}
              className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
            >
              Reject
            </button>
            <button
              onClick={acceptAll}
              className="flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
